import { configureStore } from '@reduxjs/toolkit';
import spreadsheetReducer from './Spreadsheet/reducer.ts';
import { activeViewMiddleware } from './Spreadsheet/middleware/activeViewMiddleware.ts';
import { viewPersistenceMiddleware } from './Spreadsheet/middleware/viewPersistenceMiddleware.ts';
import { filterChangeMiddleware } from './Spreadsheet/middleware/filterChangeMiddleware.ts';
import { setSaveFunction } from './Spreadsheet/saveActionSlice.ts';
import { setSaveViewsFunction } from './Spreadsheet/saveViewsActionSlice.ts';
import { setFilterChangeFunction } from './Spreadsheet/filterChangeActionSlice.ts';

export const store = configureStore({
  reducer: {
    spreadsheet: spreadsheetReducer
  },
  middleware: ( getDefaultMiddleware ) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [ 'pluginFeatures/setPluginFeatures', setSaveFunction.type, setSaveViewsFunction.type, setFilterChangeFunction.type ],
        ignoredPaths: [ 'spreadsheet.pluginFeatures.items', 'spreadsheet.saveAction.saveFunction', 'spreadsheet.saveViewsAction.saveViewsFunction', 'spreadsheet.filterChangeAction.filterChangeFunction' ],
        ignoredActionPaths: ['payload.0.condition']
      }
    }).concat( activeViewMiddleware, viewPersistenceMiddleware, filterChangeMiddleware )
});

// Export RootState from the store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;